import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const customsForms = {
  id: 'customs-forms',

  getDocumentRequestNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingCustomsformsTitle} values={{ docCount }} />,
  }),
};
